import * as React from 'react';

import * as styles from './styles/backArrow.css';
import { ArrowBack } from '../../../../base/icons';

interface IBackArrowProps {
  onClick(): void;
}

export function BackArrow({ onClick }: IBackArrowProps) {
  return (
    <div className={styles['back_arrow']}>
      <ArrowBack onClick={onClick} />
    </div>
  );
}
